/*
 * Copyright (C) 2026 - present Marek Kuzora - All Rights Reserved.
 */


import { Flex } from '@radix-ui/themes';

import { use } from 'fierry/react';

import { useArg } from 'solis/navigation';

import * as Board from 'solis/react/board';
import Tile from 'solis/react/element/tile';
import SectorGenerator from 'solis/data/sector.generator';


const DEFAULT_COUNT = 9;


const Boards = () =>
{
  const generator = use(SectorGenerator);

  return generator.getSectors().map(sector =>
  (
    <Tile key = {sector.id}>
      <Board.WithHexes hexes = {sector.zones} width = {340} height = {340} settings = {Board.Preview} />
    </Tile>
  ));
};


export default () =>
{
  const count = useArg('zoneCount') ?? DEFAULT_COUNT;

  return (
    <SectorGenerator.Export count = {count}>
      <Flex wrap = 'wrap' gap = '5' px = '5' pb = '5'>
        <Boards />
      </Flex>
    </SectorGenerator.Export>
  );
};
